export default (addressModel) => {
  let addressString = ''
  for (let k in addressModel) {
    if (!addressModel.hasOwnProperty(k)) {
      continue
    }
    switch (k) {
      case 'line1':
        addressString = addressString + `${addressModel[k]}, `
        break
      case 'line2':
        addressString = addressModel[k] !== '' ? addressString + `${addressModel[k]}, ` : addressString
        break
      case 'city':
      case 'postal':
        addressString = addressString + `${addressModel[k]} `
    }
  }
  return addressString.trim()
}
